// removed by extract-text-webpack-plugin
module.exports = {"Home":"Home__Home__1exmz","HomeContent":"Home__HomeContent__1h7Wo","Description":"Home__Description__1pad3","Links":"Home__Links__2xVXY","showSidebar":"Home__showSidebar__2gwmd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/Home.css
// module id = 77
// module chunks = 0